/* Custom JS loaded after theme.js. PDP conventions: docs/initiatives/pdp-refresh/plan.md */

(function () {
  var isSearchScope = document.body.classList.contains('_search');
  var isSearchPage = isSearchScope && !!document.querySelector('#CollectionSidebar .collection-sidebar');

  function readOpenFlag() {
    try {
      var open = localStorage.getItem('isSearchOpen') === 'true';
      if (open) localStorage.removeItem('isSearchOpen');
      return open;
    } catch (e) {
      return false;
    }
  }

  if (isSearchScope && readOpenFlag() && isSearchPage) {
    setTimeout(function () {
      document.body.classList.add('_open');
    }, 500);
  }

  var searchButton = document.querySelector('.js-search_button');
  if (!searchButton) return;
  searchButton.addEventListener('click', function () {
    if (isSearchPage) {
      document.body.classList.toggle('_open');
      return;
    }
    try {
      localStorage.setItem('isSearchOpen', 'true');
    } catch (e) {}
    window.location.href = searchButton.dataset.searchUrl || '/collections/all';
  });
})();

/* ==== [既存] 絞り込みボタン: パネルを閉じて結果へスクロール（onclick属性から参照） ==== */
function refineButton() {
  document.body.classList.remove('_open');
  var targetEl = document.querySelector('#CollectionAjaxContent');
  if (!targetEl) return;
  var targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - 120;
  window.scrollTo({ top: targetPosition });
}

/* ==== [既存] header追従化 ==== */
window.addEventListener('DOMContentLoaded', function () {
  var headerannouncement = document.querySelector('.announcement-bar');
  var re_header = document.querySelector('#SiteHeader');
  if (!headerannouncement || !re_header) return;
  var announcementHeight = headerannouncement.offsetHeight;
  var headerHeight = re_header.offsetHeight;
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > announcementHeight) {
      re_header.classList.add('fixed');
      document.body.style.marginTop = headerHeight + 'px';
    } else {
      re_header.classList.remove('fixed');
      document.body.style.marginTop = '0';
    }
  });
});

/* ==== [既存] ページトップへのスムーススクロール ==== */
window.addEventListener('DOMContentLoaded', function () {
  var pageTopBtn = document.querySelector('#page-top');
  if (!pageTopBtn) return;
  pageTopBtn.addEventListener('click', function (event) {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 100) {
      pageTopBtn.classList.add('is-visible');
    } else {
      pageTopBtn.classList.remove('is-visible');
    }
  });
});

/* ==== [W4] PDPセレクタゾーン: #5.3在庫表示の variant:change 追従 ==== */

/* Listen on the owning product section to avoid cross-product variant events. */
(function () {
  if (!document.body.classList.contains('pdpr')) return;

  var el = document.querySelector('[data-pdpr-inventory]');
  if (!el) return;

  var labelEl = el.querySelector('[data-pdpr-inventory-label]');
  if (!labelEl) return;

  var container = el.closest('[data-section-type="product"]');
  if (!container) return;

  var productId = el.getAttribute('data-product-id');
  var threshold = parseInt(el.getAttribute('data-threshold'), 10);
  if (isNaN(threshold)) threshold = 10;

  var labelIn = el.getAttribute('data-label-in') || '';
  var labelLow = el.getAttribute('data-label-low') || '';
  var labelOut = el.getAttribute('data-label-out') || '';

  function render(state, qty) {
    el.setAttribute('data-state', state);
    if (state === 'low') {
      labelEl.textContent = labelLow.replace('[count]', qty);
    } else if (state === 'out') {
      labelEl.textContent = labelOut;
    } else {
      labelEl.textContent = labelIn;
    }
    el.removeAttribute('hidden');
  }

  function apply(variant) {
    // Invalid option combinations have no inventory state.
    if (!variant) {
      el.setAttribute('hidden', '');
      return;
    }

    var byProduct = window.inventories && productId ? window.inventories[productId] : null;
    var inv = byProduct ? byProduct[variant.id] : null;

    // Untracked inventory is treated as available.
    if (!inv) {
      render('in');
      return;
    }

    var qty = parseInt(inv.quantity, 10);
    if (isNaN(qty)) qty = 0;

    if (qty > threshold) {
      render('in');
    } else if (qty > 0) {
      render('low', qty);
    } else if (inv.policy === 'continue') {
      render('in');
    } else {
      render('out');
    }
  }

  container.addEventListener('variantChange', function (evt) {
    apply(evt && evt.detail ? evt.detail.variant : null);
  });
})();

/* Paidy contract: runtime-integration-notes.md §4. */
(function () {
  if (!document.body.classList.contains('pdpr')) return;

  var paidyEl = document.querySelector('[data-pdpr-paidy]');
  if (!paidyEl) return;

  var container = paidyEl.closest('[data-section-type="product"]');
  if (!container) return;

  if (!window.theme || !theme.Currency || typeof theme.Currency.formatMoney !== 'function') return;
  var moneyFormat = theme.settings ? theme.settings.moneyFormat : null;

  container.addEventListener('variantChange', function (evt) {
    var variant = evt && evt.detail ? evt.detail.variant : null;
    if (!variant || typeof variant.price !== 'number') return;
    paidyEl.setAttribute('data-amount', theme.Currency.formatMoney(variant.price, moneyFormat));
  });
})();

/* Keep non-color option labels in sync, including invalid option combinations. */
(function () {
  if (!document.body.classList.contains('pdpr')) return;

  var labels = document.querySelectorAll('[data-pdpr-option-label]');
  if (!labels.length) return;

  var container = labels[0].closest('[data-section-type="product"]');
  if (!container) return;

  container.addEventListener('variantChange', function (evt) {
    var selected = evt && evt.detail ? evt.detail.currentlySelectedValues : null;
    if (!selected || typeof selected.forEach !== 'function') return;

    labels.forEach(function (labelEl) {
      var idx = labelEl.getAttribute('data-index');
      selected.forEach(function (opt) {
        if (opt && opt.index === idx && typeof opt.value === 'string') {
          labelEl.textContent = opt.value;
        }
      });
    });
  });
})();

/* ==== [W5] PDP購買ゾーン: #7 ATCピル内包 ＋ sticky ATCバー（S1〜S4） ==== */

/* Keep main and sticky ATC state in one owner; submit through the existing form. */
(function () {
  if (!document.body.classList.contains('pdpr')) return;

  var section = document.querySelector('[data-section-type="product"]') || document;
  var button = section.querySelector('.product-single__form [data-add-to-cart]');
  if (!button) return;

  var sourcePrice = section.querySelector('[data-product-price]');

  // SW Back in Stock contract: runtime-integration-notes.md §5.
  var restockTarget = null;
  function findRestockTarget() {
    return section.querySelector('.email-me-inlineButton')
      || section.querySelector('.product-restore-email[role="button"]')
      || section.querySelector('#sealapps-bis-widget [role="button"], #sealapps-bis-widget button');
  }
  function triggerRestock() {
    restockTarget = restockTarget || findRestockTarget();
    var el = restockTarget;
    if (!el) return false;
    var opts = { bubbles: true, cancelable: true, view: window };
    if (window.PointerEvent) el.dispatchEvent(new PointerEvent('pointerdown', opts));
    el.dispatchEvent(new MouseEvent('mousedown', opts));
    if (window.PointerEvent) el.dispatchEvent(new PointerEvent('pointerup', opts));
    el.dispatchEvent(new MouseEvent('mouseup', opts));
    el.dispatchEvent(new MouseEvent('click', opts));
    return true;
  }

  // Accept both theme.js option shapes; color is shown as a swatch.
  var colorOptionInput = section.querySelector('[data-variant-input][data-color-index]');
  var colorOptionIndex = colorOptionInput ? Number(colorOptionInput.dataset.colorIndex) : -1;
  function normalizeSummary(values) {
    if (!values || !values.length) return '';
    return values
      .map(function (v, index) {
        var optionIndex = v && v.index ? Number(String(v.index).replace('option', '')) - 1 : index;
        return optionIndex === colorOptionIndex ? '' : (v && v.value !== undefined ? v.value : v);
      })
      .filter(Boolean)
      .join(' / ');
  }

  // Reuse the picker’s rendered swatch instead of maintaining a second palette.
    function updateSwatch(swatchEl) {
    if (!swatchEl) return;
    var input = section.querySelector('[data-variant-input][data-color-name]:checked');
    var label = input && input.parentElement ? input.parentElement.querySelector('.color-swatch') : null;
    var fallbackColor = bar && bar.dataset.colorSwatch;
    if (!label && !fallbackColor) {
      swatchEl.classList.add('is-hidden');
      swatchEl.style.backgroundColor = '';
      swatchEl.style.backgroundImage = '';
      return;
    }
    swatchEl.classList.remove('is-hidden');
    if (label) {
      // Computed style includes the curated CSS palette.
      var labelStyle = window.getComputedStyle(label);
      var labelImage = labelStyle.backgroundImage;
      swatchEl.style.backgroundColor = labelStyle.backgroundColor;
      swatchEl.style.backgroundImage = labelImage === 'none' ? '' : labelImage;
    } else {
      swatchEl.style.backgroundColor = fallbackColor;
      swatchEl.style.backgroundImage = '';
    }
  }
  function syncPillSelection() {
    updateSwatch(pillSwatch);
    pillSelection.classList.toggle('is-empty', !pillSummary.textContent && pillSwatch.classList.contains('is-hidden'));
  }
  function priceText() {
    return sourcePrice ? sourcePrice.textContent.trim() : '';
  }
  // Fall back to the original money string if its symbol/number split is unknown.
  function renderPrice(el, text) {
    if (!el) return;
    var m = text ? text.match(/^(\D+?)\s*(\d.*)$/) : null;
    if (!m) { el.textContent = text || ''; return; }
    el.textContent = '';
    var sym = document.createElement('span');
    sym.className = 'pdpr-atc-price__symbol';
    sym.textContent = m[1];
    var amt = document.createElement('span');
    amt.className = 'pdpr-atc-price__amount';
    amt.textContent = m[2];
    el.appendChild(sym);
    el.appendChild(amt);
  }
  function initialSummary() {
    var currentJson = section.querySelector('[data-current-variant-json]');
    if (!currentJson) return '';
    try {
      var variant = JSON.parse(currentJson.textContent);
      if (variant && variant.options) return normalizeSummary(variant.options);
    } catch (e) {}
    return '';
  }
  function initialVariantId() {
    var currentJson = section.querySelector('[data-current-variant-json]');
    if (!currentJson) return null;
    try {
      var variant = JSON.parse(currentJson.textContent);
      return variant && variant.id ? variant.id : null;
    } catch (e) {}
    return null;
  }

  // ---- #7 ATCピル: ボタン内へ要約/価格spanを注入（PR5） ----
  var pillMain = document.createElement('span');
  pillMain.className = 'pdpr-atc-pill__main';
  var atcTextEl = button.querySelector('[data-add-to-cart-text]');
  button.insertBefore(pillMain, atcTextEl || button.firstChild);
  var pillSelection = document.createElement('span');
  pillSelection.className = 'pdpr-atc-pill__selection';
  pillMain.appendChild(pillSelection);
  var pillSwatch = document.createElement('span');
  pillSwatch.className = 'pdpr-atc-pill__swatch is-hidden';
  pillSelection.appendChild(pillSwatch);
  var pillSummary = document.createElement('span');
  pillSummary.className = 'pdpr-atc-pill__summary';
  pillSelection.appendChild(pillSummary);
  if (atcTextEl) pillMain.appendChild(atcTextEl);
  var pillPrice = document.createElement('span');
  pillPrice.className = 'pdpr-atc-pill__price';
  button.appendChild(pillPrice);

  // ---- sticky ATCバー（PR6・W5b） ----
  var bar = document.querySelector('[data-pdpr-sticky-atc]');
  if (colorOptionIndex === -1 && bar && bar.dataset.colorOptionIndex !== '') {
    colorOptionIndex = Number(bar.dataset.colorOptionIndex);
  }
  // ---- 売切れ状態の共有モデル（メインCTA＋sticky・裁定2026-07-21） ----
  // 「売切れ扱い」は選択中variantの購入可否で決まる（全売切れ・一部売切れを統一）。
  // 商材別分岐: 古着=SOLD OUT無効表示／オリジナル等=「入荷通知を受け取る」有効→SW BIS起動。
  // 在庫ありへ持ち替えたら通常ピルへ復帰（variant:changeで双方向）。7/20のS1誘導(スクロール)は本裁定で置換。
  var mainMerch = bar ? (bar.dataset.merchType || 'furugi') : 'furugi';
  var mainLabelSoldout = (bar && bar.dataset.labelSoldout) || (window.theme && theme.strings && theme.strings.soldOut) || 'SOLD OUT';
  var mainLabelNotify = (bar && bar.dataset.labelNotify) || '入荷通知を受け取る';
  if (mainMerch !== 'furugi' && window.theme && theme.strings) {
    theme.strings.soldOut = mainLabelNotify;
  }
  // 初期: theme.jsがserverで付けたdisabled属性が選択中variantの購入可否を表す
  var selectedAvailable = !button.disabled;
  var currentVariantId = initialVariantId();
  // BIS登録済みvariant（二重登録防止のdisabled化。キャンセルは復帰）。variant単位で保持。
  var submittedVariants = {};

  function setMainNormal() {
    button.setAttribute('type', 'submit');
    button.classList.remove('pdpr-atc-pill--notify', 'pdpr-atc-pill--soldout');
    // 在庫あり時のdisabled/文言（カートに追加）はtheme.jsが管理する＝ここでは触らない
  }
  function setMainSoldout() {
    if (atcTextEl) atcTextEl.textContent = mainLabelSoldout;
    button.disabled = true;
    button.setAttribute('disabled', 'disabled');
    button.setAttribute('type', 'button');
    button.classList.add('pdpr-atc-pill--soldout');
    button.classList.remove('pdpr-atc-pill--notify');
  }
  function setMainNotify(registered) {
    // registered=true: 登録済み＝グレー無効（[disabled]配色で二重登録を防ぐ）／false: 黒有効→BIS起動
    if (atcTextEl) atcTextEl.textContent = mainLabelNotify;
    button.disabled = !!registered;
    if (registered) {
      button.setAttribute('disabled', 'disabled');
      button.classList.add('disabled');
    } else {
      // theme.jsが欠品variantで付ける .disabled クラス／disabled属性を外す
      // （残るとグレー配色CSS(.add-to-cart.disabled)が効き、黒有効の通知ピルにならない）。
      button.removeAttribute('disabled');
      button.classList.remove('disabled');
    }
    button.setAttribute('type', 'button');
    button.classList.add('pdpr-atc-pill--notify');
    button.classList.remove('pdpr-atc-pill--soldout');
  }
  function applyMainCtaState() {
    var registered = !!(currentVariantId && submittedVariants[currentVariantId]);
    if (selectedAvailable) setMainNormal();
    else if (mainMerch === 'furugi') setMainSoldout();
    else setMainNotify(registered);
  }

  // ---- BIS通知モーダルの送信/キャンセル検知（送信=disabled化・キャンセル=enabled復帰） ----
  // アプリはbody直下 #email-me-frame をtoggleする。送信ボタン押下をdelegationで拾い、
  // モーダルのclose時にフラグでコミット。閉じる(×)押下は明示キャンセル＝未送信に戻す
  // （検証エラーで残った後の×閉じ＝誤コミットを防ぐ）。実DOM=mujin-dev確認2026-07-21。
  var bisWatcherActive = false;
  var bisPendingSubmit = false;
  var bisModalWasOpen = false;
  function bisFrame() { return document.getElementById('email-me-frame'); }
  function bisFrameOpen() {
    var f = bisFrame();
    return !!(f && window.getComputedStyle(f).display !== 'none' && f.offsetWidth > 0);
  }
  function bisArm() {
    if (bisWatcherActive) return;
    bisWatcherActive = true;
    document.addEventListener('click', function (e) {
      var f = bisFrame();
      var t = e.target;
      if (!f || !t || !f.contains(t) || !t.closest) return;
      if (t.closest('.frame-close, .close-box')) { bisPendingSubmit = false; return; } // 明示キャンセル
      if (t.closest('.email-me-submitButton, button[type="submit"], input[type="submit"]')) {
        bisPendingSubmit = true;
      }
    }, true);
    window.setInterval(function () {
      var open = bisFrameOpen();
      if (open && !bisModalWasOpen) {
        bisModalWasOpen = true;
        bisPendingSubmit = false; // 開いた時点でリセット
      } else if (!open && bisModalWasOpen) {
        bisModalWasOpen = false;
        // 送信押下→モーダル消滅＝登録成功とみなす（検証エラー時はモーダルが残り消滅しない）
        if (bisPendingSubmit && currentVariantId) submittedVariants[currentVariantId] = true;
        bisPendingSubmit = false;
        applyMainCtaState();
        if (stickyApi) stickyApi.refresh();
      }
    }, 300);
  }

  // 通知モードのタップ＝カート追加せずBIS通知モーダルを開く（disabled/登録済みは発火しない）。
  button.addEventListener('click', function (evt) {
    if (button.disabled) return;
    if (!button.classList.contains('pdpr-atc-pill--notify')) return;
    // カート追加経路へ渡さない（type=buttonで送信はしないが、テーマ側clickハンドラも遮断）
    evt.preventDefault();
    evt.stopPropagation();
    bisArm();
    triggerRestock();
  }, true);

  var stickyApi = bar ? initStickyBar(bar) : null;
  applyMainCtaState();

  function initStickyBar(el) {
    var d = el.dataset;
    var merch = d.merchType || 'furugi';
    // theme.jsはcart_type=drawerの時だけAjaxProductを生成する（theme.js initAjaxProductForm）。
    // page設定ではATCはネイティブsubmit→/cart遷移＝ajaxProduct:addedは発火しないため、
    // S3演出はdrawer時のみ有効化し、page時は遷移に任せる（設定どちらでも正しく動く適応型）
    var ajaxCart = d.cartType === 'drawer';
    var cartUrl = d.cartUrl || '/cart';
    var labels = {
      select: d.labelSelect, atc: d.labelAtc, added: d.labelAdded,
      cart: d.labelCart, soldout: d.labelSoldout, notify: d.labelNotify
    };
    var actionEl = el.querySelector('[data-pdpr-sticky-action]');
    var selectionEl = el.querySelector('[data-pdpr-sticky-selection]');
    var swatchEl = el.querySelector('[data-pdpr-sticky-swatch]');
    var summaryEl = el.querySelector('[data-pdpr-sticky-summary]');
    var labelEl = el.querySelector('[data-pdpr-sticky-label]');
    var priceSlot = el.querySelector('[data-pdpr-sticky-price]');

    var inAddedState = false;   // S3 の間はバー表示をS3が占有する
    var hasSeenMainAtc = false; // 初回FVでATC未到達の間はstickyを出さない
    // メインATCがビューポートの「上」に抜けた時だけ表示する。
    // 下から戻ってATCを通過した時（ATCが画面下にある）は表示しない。
    var mainAtcAboveViewport = false;
    var browseSectionInView = false;
    var lastSummary = '';
    var addedTimer = null;

    // 再入荷通知トリガーはIIFEスコープの共用ヘルパ（findRestockTarget/triggerRestock）を使う。
    // S4-通知(オリジナル未登録)で行き先(BISトリガー)が不在の時だけバーを隠す（押せない通知を出さない）。
    // S2/S4-SOLD OUT(古着)/S4-登録済み(グレー表示)は常に出す。
    function isSuppressed() {
      if (selectedAvailable) return false;
      if (merch === 'furugi') return false;
      if (currentVariantId && submittedVariants[currentVariantId]) return false;
      restockTarget = restockTarget || findRestockTarget();
      return !restockTarget;
    }

    // 選択中variantが購入可なら S2（カート追加）、不可なら S4（商材別の売切れ表示）。
    // 旧S1（未選択→スクロール誘導）は裁定2026-07-21で廃止＝選択variant単位の売切れ扱いに統一。
    function computeState() {
      return selectedAvailable ? 'S2' : 'S4';
    }

    function setEnabled(on) {
      actionEl.disabled = !on;
      if (on) actionEl.removeAttribute('aria-disabled');
      else actionEl.setAttribute('aria-disabled', 'true');
    }

    function applyState() {
      if (inAddedState) return; // S3 が占有中
      var state = computeState();
      el.setAttribute('data-state', state);
      el.classList.toggle('pdpr-sticky-atc--soldout', state === 'S4');
      if (state === 'S2') {
        labelEl.textContent = labels.atc;
        setEnabled(true);
      } else { // S4（選択variant欠品）
        var registered = !!(currentVariantId && submittedVariants[currentVariantId]);
        if (merch === 'furugi') {
          labelEl.textContent = labels.soldout;
          setEnabled(false); // 非インタラクティブ（状態表示・タップ不可）
        } else if (registered) {
          labelEl.textContent = labels.notify;
          setEnabled(false); // 登録済み＝グレー無効（二重登録防止）
        } else {
          labelEl.textContent = labels.notify;
          setEnabled(true);
        }
      }
      updateVisibility();
    }

    function updateSummary(summaryStr) {
      lastSummary = summaryStr;
      if (!inAddedState) summaryEl.textContent = summaryStr;
    }
    function updateSelectionSwatch() {
      updateSwatch(swatchEl);
      selectionEl.classList.toggle('is-empty', !summaryEl.textContent && swatchEl.classList.contains('is-hidden'));
    }
    function mirrorPrice() {
      if (!inAddedState) renderPrice(priceSlot, priceText());
    }

    function updateVisibility() {
      var show = hasSeenMainAtc && mainAtcAboveViewport && !browseSectionInView && !isSuppressed();
      // 古着×選択variant売切れ(S4)はstickyを出さない（メインATCのSOLD OUT表示に委ねる／裁定2026-07-22）。
      // data-stateで判定＝S3占有中(inAddedState='S3')は除外され、変更もvariantChange毎のapplyStateで双方向反映。
      if (show && merch === 'furugi' && el.getAttribute('data-state') === 'S4') show = false;
      // aria-hidden配下にフォーカスを残すとa11y違反＝隠す前にバー内フォーカスを外す
      if (!show && document.activeElement && el.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      el.classList.toggle('is-visible', show);
      el.setAttribute('aria-hidden', show ? 'false' : 'true');
      // バー表示中はページ最下部（フッター等）がバーに隠れないようbodyへ余白を補償
      document.body.classList.toggle('pdpr-sticky-atc-open', show);
    }

    function enterAddedState() {
      inAddedState = true;
      clearTimeout(addedTimer);
      el.setAttribute('data-state', 'S3');
      el.classList.add('pdpr-sticky-atc--added');
      el.classList.remove('pdpr-sticky-atc--soldout');
      summaryEl.textContent = labels.added;
      labelEl.textContent = labels.cart;
      priceSlot.textContent = '';
      setEnabled(true);
      updateVisibility();
      addedTimer = setTimeout(function () {
        inAddedState = false;
        el.classList.remove('pdpr-sticky-atc--added');
        summaryEl.textContent = lastSummary;
        mirrorPrice();
        applyState();
      }, 3200);
    }

    actionEl.addEventListener('click', function () {
      if (inAddedState) { window.location.href = cartUrl; return; }
      if (actionEl.disabled) return; // 古着SOLD OUT・登録済みは非インタラクティブ
      var state = el.getAttribute('data-state');
      if (state === 'S2') {
        // 既存ATCボタンのclickで既存form経路へ委譲（drawer=AJAX／page=ネイティブsubmit→/cart遷移）
        if (!button.disabled) {
          if (!ajaxCart) el.classList.add('pdpr-sticky-atc--pressed');
          button.click();
        }
      } else if (state === 'S4' && merch !== 'furugi') {
        // オリジナル等の売切れvariant＝BIS通知モーダルを起動（送信/キャンセルの状態管理も起動）
        bisArm();
        triggerRestock();
      }
    });

    // 出現制御: 購買ゾーン(既存ATCボタン)を一度見た後、それが画面上へ抜けたら表示。
    // IntersectionObserver非対応環境ではバーは出ない（メインATCは常に使える＝安全側の縮退）
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) hasSeenMainAtc = true;
          mainAtcAboveViewport = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
          updateVisibility();
        });
      }, { threshold: 0 }).observe(button);

      // 下部の回遊セクションでは購入CTAを重ねず、商品カードの閲覧に集中させる。
      var browseSections = document.querySelectorAll(
        'product-recommendations[data-intent="related"], [data-section-type="recently-viewed"]'
      );
      if (browseSections.length) {
        var visibleBrowseSections = [];
        var browseObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var index = visibleBrowseSections.indexOf(entry.target);
            if (entry.isIntersecting && index === -1) visibleBrowseSections.push(entry.target);
            if (!entry.isIntersecting && index !== -1) visibleBrowseSections.splice(index, 1);
          });
          browseSectionInView = visibleBrowseSections.length > 0;
          updateVisibility();
        }, { threshold: 0, rootMargin: '0px 0px 160px 0px' });

        for (var i = 0; i < browseSections.length; i++) {
          browseObserver.observe(browseSections[i]);
        }
      }
    }

    return {
      onSummary: updateSummary,
      onSwatch: updateSelectionSwatch,
      onPrice: mirrorPrice,
      refresh: applyState,
      enterAddedState: enterAddedState,
      usesAjaxCart: ajaxCart,
      init: applyState
    };
  }

  // ---- 共有: 初期反映 ＋ 購読（変更発行はvariant-selector1つ・購読はここ1本） ----
  var initSummary = initialSummary();
  pillSummary.textContent = initSummary;
  syncPillSelection();
  renderPrice(pillPrice, priceText());
  if (stickyApi) {
    stickyApi.onSummary(initSummary);
    stickyApi.onSwatch();
    stickyApi.onPrice();
    stickyApi.init();
  }

  // 別商品イベントの誤受信防止（codexレビュー2026-07-20・旧Q2地雷の解消）:
  // documentの variant:change は同一ページ上の別商品(Quick Shop等)でも発火する。
  // [W4]と同じく本体セクションcontainerの非バブル variantChange を購読する（container不在=no-op縮退）。
  var container = button.closest('[data-section-type="product"]');
  if (container) {
    container.addEventListener('variantChange', function (evt) {
      var detail = evt.detail || {};
      // detail.variant は不成立の組合せで null。要約は選択値配列から出すため null 非依存
      var summary = normalizeSummary(detail.currentlySelectedValues);
      pillSummary.textContent = summary;
      syncPillSelection();
      // 選択中variantの購入可否とidを共有モデルへ反映（メインCTA・stickyが購読）。
      // detail.variant は不成立組合せ(null)で購入不可扱い。
      var v = detail.variant;
      selectedAvailable = !!(v && v.available);
      currentVariantId = v && v.id ? v.id : null;
      // 状態の適用は同期で行う（theme.jsはvariantChange発火前にボタンを更新済み＝この後に上書きすれば勝つ）。
      // rAFに逃がすと非表示タブでコールバックが発火せず反映されない（実測2026-07-21）＝背景でも動く同期にする。
      renderPrice(pillPrice, priceText());
      if (stickyApi) {
        stickyApi.onSummary(summary);
        stickyApi.onSwatch();
        stickyApi.onPrice();
        stickyApi.refresh();
      }
      // 選択variant単位の売切れ表示（SOLD OUT／入荷通知／通常ピル）を毎回上書きし直す（冪等）。
      applyMainCtaState();
      // 価格はtheme.jsの更新が1フレーム遅れ得るため次フレームで再ミラー（保険・表示可能タブのみ）。
      window.requestAnimationFrame(function () {
        renderPrice(pillPrice, priceText());
        if (stickyApi) stickyApi.onPrice();
      });
    });
  }

  // S2→S3: 既存ATCのAJAX成功(ajaxProduct:added・form発火→bubbleでdocumentに到達)。
  // page設定ではこのイベント自体が発火しない（ネイティブ遷移）ためdrawer時のみ購読。
  // 別商品イベントの誤受信防止（codexレビュー2026-07-20・旧Q2地雷の解消）:
  // documentへbubbleした ajaxProduct:added は別商品(Quick Shop等)由来もあり得るため、
  // 本体formに含まれる／本体ATCボタン発の追加に限定する（判定不能時は遷移しない安全側）。
  if (stickyApi && stickyApi.usesAjaxCart) {
    document.addEventListener('ajaxProduct:added', function (evt) {
      var target = evt && evt.target;
      var detail = (evt && evt.detail) || {};
      var isOurForm = !!(target && container && container.contains(target));
      var isOurButton = !!(detail.addToCartBtn && detail.addToCartBtn === button);
      if (!isOurForm && !isOurButton) return;
      stickyApi.enterAddedState();
    });
  }
})();

/* ==== [W6] PDPモーダル基盤: 開閉・オーバーレイ・スクロールロック ==== */
(function () {
  'use strict';

  var body = document.body;
  if (!body) return;

  // 契約: data-pdpr-modal-open の値と一致する data-pdpr-modal="<id>" を開く（plan.md §2）
  var OPEN_ATTR = 'data-pdpr-modal-open';
  var OPEN_CLASS = 'pdpr-modal--open';
  var CLOSING_CLASS = 'pdpr-modal--closing';
  var PARKED_CLASS = 'pdpr-modal--parked';
  var HIDE_FALLBACK_MS = 400;
  var FOCUSABLE = 'a[href], button:not([disabled]), textarea, input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var activeModal = null;
  var lastTrigger = null;
  var savedScrollY = 0;
  var reviewHistoryActive = false;
  var reviewTouchStart = null;
  var scrollRestorationPrev = null;
  var pendingHistoryConsume = false;

  function isReviewModal(modal) {
    return !!(modal && modal.getAttribute('data-pdpr-modal') === 'review');
  }

  // Reviews always use a sheet/drawer; other PDP modals use sheets on mobile.
  function isSheetModal(modal) {
    if (isReviewModal(modal)) return true;
    if (!modal) return false;
    return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
  }

  // Theme and Paidy modals share this reference-counted scroll lock.
  var scrollLockCount = 0;

  function lockScroll() {
    scrollLockCount++;
    if (scrollLockCount > 1) return;
    savedScrollY = window.pageYOffset || 0;
    body.style.top = -savedScrollY + 'px';
    body.classList.add('pdpr-modal-open');
  }

  // Allow the modal and safe-area strip to paint before iOS samples the page.
  var LOCK_DELAY_MS = 32;
  var pendingLockTimers = [];

  function acquireScrollLock() {
    var t = setTimeout(function () {
      var idx = pendingLockTimers.indexOf(t);
      if (idx !== -1) pendingLockTimers.splice(idx, 1);
      lockScroll();
    }, LOCK_DELAY_MS);
    pendingLockTimers.push(t);
  }

  function releaseScrollLock() {
    if (pendingLockTimers.length) {
      clearTimeout(pendingLockTimers.pop());
      return;
    }
    unlockScroll();
  }

  function unlockScroll() {
    if (!scrollLockCount) return;
    scrollLockCount--;
    if (scrollLockCount) return;
    body.classList.remove('pdpr-modal-open');
    body.style.top = '';
    // why: new.css の html{scroll-behavior:smooth} が効くと scrollTo 復元がアニメ化し、
    //      position:fixed 解除でトップへ戻った直後に元位置まで「走って」見える（PR#22実機・iOS）。
    //      復元の間だけ scrollingElement 上の inline で smooth を無効化し即時ジャンプで戻す
    //      （同期処理内で元へ戻すため他挙動には残さない）。
    var se = document.scrollingElement || document.documentElement;
    var prevBehavior = se.style.scrollBehavior;
    se.style.scrollBehavior = 'auto';
    window.scrollTo(0, savedScrollY);
    se.style.scrollBehavior = prevBehavior;
  }

  // why: id に querySelector で危険な文字が来ても壊れないよう属性値を直接比較で探索する（CSS.escape非対応環境の防御）
  function findModal(id) {
    if (!id) return null;
    var all = document.querySelectorAll('[data-pdpr-modal]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-pdpr-modal') === id) return all[i];
    }
    return null;
  }

  function focusables(modal) {
    var dialog = modal.querySelector('.pdpr-modal__dialog');
    if (!dialog) return [];
    var nodes = dialog.querySelectorAll(FOCUSABLE);
    var visible = [];
    for (var i = 0; i < nodes.length; i++) {
      // offsetParent=null は非表示要素＝トラップ対象から除外
      if (nodes[i].offsetParent !== null) visible.push(nodes[i]);
    }
    return visible;
  }

  // why: keydownトラップはTabキー経路しか塞げず、FOCUSABLEセレクタとブラウザ実タブ順の差や
  //      支援技術のシーケンシャルナビ（keydownを経ない）で背後へ抜ける（実機QA 2026-07-20）。
  //      対応環境では背景をinert化して構造ごと塞ぐ。モーダルはbody直下でなく本文内に
  //      レンダリングされる＝祖先チェーンの各階層で兄弟にinertを付与する。
  //      非対応環境は属性が無視されkeydown/focusinのJSトラップが受け持つ縮退。
  var inerted = [];

  function applyInert(modal) {
    var node = modal;
    while (node && node !== body && node.parentElement) {
      var parent = node.parentElement;
      for (var i = 0; i < parent.children.length; i++) {
        var sib = parent.children[i];
        if (sib === node) continue;
        var tag = sib.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK') continue;
        // 免除要素（body直下のPhotoSwipe）はモーダルの上に重ねて操作させる＝inertを付けない
        if (sib.hasAttribute('data-pdpr-inert-exempt')) continue;
        // 他所有のinert（元から付いているもの）はclose時に剥がしてはいけない＝自分の付与分のみ記録
        if (sib.hasAttribute('inert')) continue;
        sib.setAttribute('inert', '');
        inerted.push(sib);
      }
      node = parent;
    }
  }

  function clearInert() {
    for (var i = 0; i < inerted.length; i++) {
      inerted[i].removeAttribute('inert');
    }
    inerted = [];
  }

  function cancelPendingHide(modal) {
    var hadPending = !!(modal._pdprHideTimer || modal._pdprHideHandler);
    if (modal._pdprHideTimer) {
      clearTimeout(modal._pdprHideTimer);
      modal._pdprHideTimer = null;
    }
    if (modal._pdprHideHandler) {
      modal.removeEventListener('transitionend', modal._pdprHideHandler);
      modal._pdprHideHandler = null;
    }
    return hadPending;
  }

  function revealModal(modal) {
    var hadPendingHide = cancelPendingHide(modal);
    modal.classList.remove(CLOSING_CLASS);
    if (hadPendingHide) releaseScrollLock();
    modal.hidden = false;
    modal.classList.remove(PARKED_CLASS);
    void modal.offsetWidth;
    modal.classList.add(OPEN_CLASS);
  }

  function hideAfterExit(modal) {
    cancelPendingHide(modal);
    function finish() {
      cancelPendingHide(modal);
      // park型はレイアウトを保って隠す（pdpr-modal.liquid の park 参照）
      if (modal.hasAttribute('data-pdpr-modal-park')) {
        modal.classList.add(PARKED_CLASS);
      } else {
        modal.hidden = true;
      }
      modal.classList.remove(CLOSING_CLASS);
      releaseScrollLock();
    }
    function onTransitionEnd(e) {
      if (e.propertyName !== 'transform') return;
      if (!e.target || !e.target.classList || !e.target.classList.contains('pdpr-modal__dialog')) return;
      finish();
    }
    modal._pdprHideHandler = onTransitionEnd;
    modal.addEventListener('transitionend', onTransitionEnd);
    modal._pdprHideTimer = setTimeout(finish, HIDE_FALLBACK_MS);
  }

  function openModal(modal, trigger) {
    if (!modal || activeModal === modal) return;
    if (activeModal) closeModal(false);
    activeModal = modal;
    lastTrigger = trigger || null;
    revealModal(modal);
    modal.setAttribute('aria-hidden', 'false');
    acquireScrollLock();
    applyInert(modal);
    // レビューだけはブラウザの戻る操作を「PDPから離脱」ではなく「シートを閉じる」に割り当てる。
    // 同じURLの履歴を1件積み、X/overlay/Esc/下スワイプで閉じた場合もその履歴を回収する。
    if (isReviewModal(modal)) {
      if (!reviewHistoryActive) {
        if ('scrollRestoration' in window.history) {
          scrollRestorationPrev = window.history.scrollRestoration;
          window.history.scrollRestoration = 'manual';
        }
        window.history.pushState({ pdprReviewModal: true }, '', window.location.href);
        reviewHistoryActive = true;
      }
    }
    var list = focusables(modal);
    if (list.length) {
      list[0].focus();
    } else {
      var dialog = modal.querySelector('.pdpr-modal__dialog');
      if (dialog) dialog.focus();
    }
  }

  function closeModal(restoreFocus, syncReviewHistory) {
    if (!activeModal) return;
    var wasReview = isReviewModal(activeModal);
    activeModal.setAttribute('aria-hidden', 'true');
    activeModal.classList.remove(OPEN_CLASS);
    activeModal.classList.add(CLOSING_CLASS);
    hideAfterExit(activeModal);
    activeModal = null;
    clearInert();
    if (restoreFocus !== false && lastTrigger && typeof lastTrigger.focus === 'function') {
      lastTrigger.focus({ preventScroll: true });
    }
    lastTrigger = null;
    if (wasReview && reviewHistoryActive) {
      reviewHistoryActive = false;
      if (syncReviewHistory !== false && window.history.state && window.history.state.pdprReviewModal) {
        pendingHistoryConsume = true;
        window.history.back();
      }
    }
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[' + OPEN_ATTR + ']');
    if (trigger) {
      var modal = findModal(trigger.getAttribute(OPEN_ATTR));
      if (!modal) return; // 前方互換: 本体が無ければ何もしない
      e.preventDefault();
      openModal(modal, trigger);
      return;
    }

    if (!activeModal) return;
    if (target.closest('[data-pdpr-modal-close]')) {
      e.preventDefault();
      closeModal(true);
      return;
    }
    if (target.closest('[data-pdpr-modal-overlay]')) {
      closeModal(true);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!activeModal) return;
    if (e.key === 'Escape' || e.keyCode === 27) {
      closeModal(true);
      return;
    }
    if (e.key === 'Tab' || e.keyCode === 9) {
      var list = focusables(activeModal);
      if (!list.length) {
        e.preventDefault();
        return;
      }
      var first = list[0];
      var last = list[list.length - 1];
      // ダイアログ内の非フォーカス要素クリックでfocusがbodyへ抜けた後のTabは
      // 背景要素へ移る＝ダイアログ外なら先頭へ引き戻す（PR#22レビュー指摘2）
      var dialog = activeModal.querySelector('.pdpr-modal__dialog');
      if (dialog && !dialog.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
        return;
      }
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  function restoreScrollRestorationSoon() {
    if (scrollRestorationPrev === null) return;
    var value = scrollRestorationPrev;
    scrollRestorationPrev = null;
    setTimeout(function () {
      window.history.scrollRestoration = value;
    }, 2000);
  }

  window.addEventListener('popstate', function () {
    if (pendingHistoryConsume) {
      pendingHistoryConsume = false;
      var y = savedScrollY;
      var reassert = function () {
        if (scrollLockCount) return;
        var se = document.scrollingElement || document.documentElement;
        var prev = se.style.scrollBehavior;
        se.style.scrollBehavior = 'auto';
        window.scrollTo(0, y);
        se.style.scrollBehavior = prev;
      };
      setTimeout(reassert, 0);
      setTimeout(reassert, 250);
      setTimeout(reassert, 600);
    }
    if (!isReviewModal(activeModal)) {
      restoreScrollRestorationSoon();
      return;
    }
    reviewHistoryActive = false;
    closeModal(true, false);
    restoreScrollRestorationSoon();
  });

  // 写真詳細の右上×は「ギャラリーだけを閉じる」ではなく、レビューシート全体を閉じる。
  // Judge.me がbody直下に生成する詳細から、基盤の公開イベントで責務を戻す。
  document.addEventListener('pdpr:close-review-modal', function () {
    if (!isReviewModal(activeModal)) return;
    closeModal(true);
  });

  // SPの下方向スワイプ。リストが先頭にあり、横移動より縦移動が明確に大きい場合だけ閉じる。
  // 写真カルーセルの横スワイプと競合しないよう、touchmoveではDOMを動かさずtouchendで裁定する。
  document.addEventListener(
    'touchstart',
    function (e) {
      reviewTouchStart = null;
      if (!isSheetModal(activeModal) || !e.touches || e.touches.length !== 1) return;
      // why: 入力要素上の下方向ドラッグはカーソル移動・テキスト選択・textarea内スクロールと
      //      区別できない＝問い合わせフォーム操作中の誤閉じを防ぐため入力起点は裁定から外す
      if (e.target && e.target.closest && e.target.closest('input, textarea, select')) return;
      var bodyScroller = activeModal.querySelector('.pdpr-modal__body');
      if (!bodyScroller || bodyScroller.scrollTop > 0) return;
      var touch = e.touches[0];
      reviewTouchStart = { x: touch.clientX, y: touch.clientY };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    function (e) {
      if (!reviewTouchStart || !isSheetModal(activeModal) || !e.changedTouches || !e.changedTouches.length) {
        reviewTouchStart = null;
        return;
      }
      var touch = e.changedTouches[0];
      var dx = touch.clientX - reviewTouchStart.x;
      var dy = touch.clientY - reviewTouchStart.y;
      reviewTouchStart = null;
      if (dy >= 72 && dy > Math.abs(dx)) closeModal(true);
    },
    { passive: true }
  );

  // why: keydownで防げない経路（タブ順ズレ・支援技術ナビ・スクリプト起因）でフォーカスが
  //      背後に着地した場合の最終防衛＝どう抜けてもダイアログへ引き戻す。bubble段登録＝
  //      レビュー詳細がアプリ側でbody直下に出る場合は、実DOM確認後に境界処理を追加する。
  document.addEventListener('focusin', function (e) {
    if (!activeModal) return;
    var dialog = activeModal.querySelector('.pdpr-modal__dialog');
    if (!dialog) return;
    if (dialog.contains(e.target)) return;
    var list = focusables(activeModal);
    if (list.length) {
      list[0].focus();
    } else {
      dialog.focus();
    }
  });

  /* Paidy injects its modal dynamically; class prefixes are the integration contract. */
  (function () {
    if (!document.querySelector('[data-pdpr-paidy]')) return;
    if (typeof MutationObserver === 'undefined') return;

    var PAIDY_MODAL_MARK = '[class*="_paidy-promotional-messaging-upsell-modal"]';
    var PAIDY_CLOSE = '[class*="_paidy-promotional-messaging-upsell-modal-close"]';
    var paidyModalRoot = null;
    var paidyClosing = false;
    var paidyXTimer = null;
    var bypassCloseIntercept = false;
    var reducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

    function paidyCloseBtn() {
      return paidyModalRoot && paidyModalRoot.querySelector(PAIDY_CLOSE);
    }

    function paidyPanel() {
      var closeBtn = paidyCloseBtn();
      return closeBtn ? closeBtn.parentElement : null;
    }

    function hidePaidyX() {
      var x = paidyCloseBtn();
      if (!x) return;
      x.style.transition = 'none';
      x.style.opacity = '0';
    }

    function showPaidyX() {
      var x = paidyCloseBtn();
      if (!x) return;
      x.style.transition = 'opacity 0.15s ease';
      x.style.opacity = '';
    }

    function isPaidyDesktop() {
      return !!(window.matchMedia && window.matchMedia('(min-width: 768px)').matches);
    }

    // Paidyはスタイルをinline !importantで注入するため、PCレイアウトもJSで上書きする。
    // アプリ更新でDOMが変わった場合は何も変更せず、標準表示へ縮退する。
    function applyPaidyDesktopLayout() {
      if (!paidyModalRoot || !isPaidyDesktop()) return;
      var panel = paidyPanel();
      var x = paidyCloseBtn();
      if (!panel) return;
      var set = function (el, props) {
        for (var k in props) el.style.setProperty(k, props[k], 'important');
      };
      set(paidyModalRoot, {
        position: 'fixed',
        inset: '0',
        width: 'auto',
        height: 'auto',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        padding: '16px',
        background: 'rgba(0, 0, 0, 0.5)',
      });
      set(panel, {
        position: 'relative',
        inset: 'auto',
        margin: '0',
        width: 'min(480px, 100%)',
        'max-height': 'calc(100vh - 64px)',
        'overflow-y': 'auto',
        background: '#fff',
        'border-radius': '12px',
        'box-shadow': '0 8px 32px rgba(0, 0, 0, 0.2)',
        padding: '8px 0 16px',
      });
      if (x) set(x, { position: 'absolute', top: '16px', right: '16px' });
    }

    function animatePaidyOpen() {
      if (reducedMotion) return;
      var panel = paidyPanel();
      if (!panel) return;
      hidePaidyX();
      panel.style.transition = 'none';
      if (isPaidyDesktop()) {
        // PCは中央ダイアログとして短い移動とフェードで表示する。
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(16px)';
      } else {
        panel.style.transform = 'translateY(100%)';
      }
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease-out';
          panel.style.opacity = '';
          panel.style.transform = '';
        });
      });
      clearTimeout(paidyXTimer);
      paidyXTimer = setTimeout(function () {
        if (!paidyClosing) showPaidyX();
      }, 350);
    }

    function animatePaidyClose(onDone) {
      if (paidyClosing) return;
      var panel = paidyPanel();
      if (reducedMotion || !panel) {
        onDone();
        return;
      }
      paidyClosing = true;
      clearTimeout(paidyXTimer);
      var x = paidyCloseBtn();
      if (x) {
        x.style.transition = 'opacity 0.15s ease';
        x.style.opacity = '0';
      }
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        paidyClosing = false;
        onDone();
      }
      panel.style.transition = 'opacity 0.3s ease, transform 0.3s ease-out';
      if (isPaidyDesktop()) {
        panel.style.opacity = '0';
        panel.style.transform = 'translateY(16px)';
      } else {
        panel.style.transform = 'translateY(100%)';
      }
      panel.addEventListener('transitionend', function onEnd(e) {
        if (e.propertyName !== 'transform') return;
        panel.removeEventListener('transitionend', onEnd);
        finish();
      });
      setTimeout(finish, 400);
    }

    function closePaidy() {
      if (!paidyModalRoot || !paidyModalRoot.querySelector(PAIDY_CLOSE)) return;
      animatePaidyClose(function () {
        var btn = paidyModalRoot && paidyModalRoot.querySelector(PAIDY_CLOSE);
        if (!btn) return;
        bypassCloseIntercept = true;
        btn.click();
        bypassCloseIntercept = false;
      });
    }

    function findMark(node) {
      if (!node || node.nodeType !== 1) return null;
      if (node.matches && node.matches(PAIDY_MODAL_MARK)) return node;
      return node.querySelector ? node.querySelector(PAIDY_MODAL_MARK) : null;
    }

    function topLevelOf(el) {
      var n = el;
      while (n.parentElement && n.parentElement !== body) n = n.parentElement;
      return n;
    }

    var observer = new MutationObserver(function (mutations) {
      if (paidyModalRoot && !paidyModalRoot.isConnected) {
        paidyModalRoot = null;
        paidyClosing = false;
        clearTimeout(paidyXTimer);
        releaseScrollLock();
      }
      if (paidyModalRoot) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var mark = findMark(added[j]);
          if (!mark) continue;
          paidyModalRoot = topLevelOf(mark);
          acquireScrollLock();
          applyPaidyDesktopLayout();
          animatePaidyOpen();
          return;
        }
      }
    });
    observer.observe(body, { childList: true, subtree: true });

    var paidyTouchStart = null;

    function scrollableAncestor(el) {
      var n = el;
      while (n && n !== paidyModalRoot && n.nodeType === 1) {
        if (n.scrollHeight > n.clientHeight) {
          var oy = getComputedStyle(n).overflowY;
          if (oy === 'auto' || oy === 'scroll') return n;
        }
        n = n.parentElement;
      }
      return null;
    }

    document.addEventListener(
      'touchstart',
      function (e) {
        paidyTouchStart = null;
        if (!paidyModalRoot || !e.touches || e.touches.length !== 1) return;
        var target = e.target;
        if (!target || !paidyModalRoot.contains(target)) return;
        var scroller = scrollableAncestor(target);
        if (scroller && scroller.scrollTop > 0) return;
        paidyTouchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
      },
      { passive: true }
    );

    document.addEventListener(
      'touchend',
      function (e) {
        if (!paidyTouchStart || !paidyModalRoot || !e.changedTouches || !e.changedTouches.length) {
          paidyTouchStart = null;
          return;
        }
        var touch = e.changedTouches[0];
        var dx = touch.clientX - paidyTouchStart.x;
        var dy = touch.clientY - paidyTouchStart.y;
        paidyTouchStart = null;
        if (dy < 72 || dy <= Math.abs(dx)) return;
        closePaidy();
      },
      { passive: true }
    );

    document.addEventListener(
      'click',
      function (e) {
        if (bypassCloseIntercept || !paidyModalRoot) return;
        var target = e.target;
        if (!target || typeof target.closest !== 'function') return;
        var closeBtn = target.closest(PAIDY_CLOSE);
        if (!closeBtn || !paidyModalRoot.contains(closeBtn)) return;
        e.preventDefault();
        e.stopPropagation();
        closePaidy();
      },
      true
    );
  })();
})();

/* ==== [W6b] Judge.me写真詳細: 横スワイプ=画像、丸ボタン=写真付きレビュー間の移動（spike） ==== */
(function () {
  'use strict';

  // Judge.me v719 実DOM（mujin-dev 2026-08-24）。依存点をここへ集約し、見つからなければ
  // 純正ライトボックスへそのまま縮退する。テーマ側はレビュー本文や媒体配列を複製しない。
  // 写真詳細（レビューカード起点）とLightbox（レビュー一覧の写真一覧起点）はJudge.meでは別モーダル。
  // 実DOMのカルーセル・本文・操作要素は共通のため、テーマの写真閲覧体験は同じ境界classで統一する。
  var DETAIL =
    '.jdgm-modal__content[aria-label="Review Media Gallery"], .jdgm-modal__content[aria-label="Lightbox"]';
  var DETAIL_REVIEW = '.jm-review-item[review-uuid]';
  var LIST_REVIEW = '[data-pdpr-judgeme-widget] .jdgm-review-list .jm-review-item[review-uuid]';
  var MEDIA_TRIGGER = '[role="button"][aria-label="View review image"]';
  var PREV = '.jm-navigation__previous';
  var NEXT = '.jm-navigation__next';
  var CLOSE = '.jm-indicator__close';
  var BACK_TO_REVIEWS = '[data-pdpr-judgeme-back-to-reviews]';
  var GALLERY_MODAL = '.jdgm-modal';
  var DETAIL_SHEET_CLASS = 'pdpr-judgeme-media-detail-modal';
  var RETURNING_TO_LIST = 'data-pdpr-judgeme-returning-to-list';
  var SUPPRESS_RING_CLASS = 'pdpr-suppress-focus-ring';

  function visibleDetail() {
    var details = document.querySelectorAll(DETAIL);
    for (var i = 0; i < details.length; i++) {
      if (details[i].getClientRects().length) return details[i];
    }
    return null;
  }

  function photoReviews() {
    var nodes = document.querySelectorAll(LIST_REVIEW);
    var result = [];
    for (var i = 0; i < nodes.length; i++) {
      // 検索・評価フィルターで非表示になったレビューは「現在の一覧順」から除外する。
      if (!nodes[i].getClientRects().length) continue;
      if (!nodes[i].querySelector(MEDIA_TRIGGER)) continue;
      result.push(nodes[i]);
    }
    return result;
  }

  function context(detail) {
    if (!detail) return null;
    var detailReview = detail.querySelector(DETAIL_REVIEW);
    var uuid = detailReview && detailReview.getAttribute('review-uuid');
    if (!uuid) return null;
    var reviews = photoReviews();
    for (var i = 0; i < reviews.length; i++) {
      if (reviews[i].getAttribute('review-uuid') === uuid) {
        return { reviews: reviews, index: i };
      }
    }
    return null;
  }

  function syncButtons(detail) {
    // 詳細はJudge.meがbody直下へ動的生成する。テーマ所有クラスを境界として付け、
    // 見た目の上書きがaria-labelやアプリのモーダル階層へ直接依存し続けないようにする。
    detail.classList.add('pdpr-judgeme-media-detail');
    enableDetailSheetMode(detail);
    ensureBackToReviewsButton(detail);
    var ctx = context(detail);
    if (!ctx) return;
    var prev = detail.querySelector(PREV);
    var next = detail.querySelector(NEXT);
    if (prev) {
      prev.setAttribute('aria-label', '前の写真付きレビュー');
      prev.disabled = ctx.index === 0;
    }
    if (next) {
      next.setAttribute('aria-label', '次の写真付きレビュー');
      next.disabled = ctx.index === ctx.reviews.length - 1;
    }
  }

  function enableDetailSheetMode(detail) {
    var modal = detail && detail.closest && detail.closest(GALLERY_MODAL);
    if (modal) modal.classList.add(DETAIL_SHEET_CLASS);
  }


  function clearDetailSheetMode() {
    var modals = document.querySelectorAll('.' + DETAIL_SHEET_CLASS);
    for (var i = 0; i < modals.length; i++) {
      modals[i].classList.remove(DETAIL_SHEET_CLASS);
    }
  }

  function returnToReviewList(detail) {
    var close = detail && detail.querySelector(CLOSE);
    if (!close || typeof close.click !== 'function') return false;
    // 投稿間移動・左上戻るは、Judge.meの「ギャラリーを閉じる」だけを使う。
    // 右上×のシート終了イベントと区別するため、同期クリック中だけ印を付ける。
    detail.setAttribute(RETURNING_TO_LIST, '');
    close.click();
    window.setTimeout(function () {
      detail.removeAttribute(RETURNING_TO_LIST);
    }, 0);
    return true;
  }

  function ensureBackToReviewsButton(detail) {
    if (!detail || detail.querySelector(BACK_TO_REVIEWS)) return;

    // Judge.meは一覧へ戻す公開APIを持たないため、既存のギャラリー閉じる操作を呼び出す。
    // 独自buttonはdata属性で識別し、Judge.meが所有するDOM/イベントには手を加えない。
    var button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('data-pdpr-judgeme-back-to-reviews', '');
    button.setAttribute('aria-label', 'レビュー一覧に戻る');
    button.addEventListener('click', function () {
      returnToReviewList(detail);
    });
    // iOSの自動フォーカスではリングを抑制し、Tab操作の開始後に解除する。
    button.classList.add(SUPPRESS_RING_CLASS);
    detail.insertBefore(button, detail.firstChild);
  }

  function moveReview(detail, direction) {
    var ctx = context(detail);
    if (!ctx) return false;
    var target = ctx.reviews[ctx.index + direction];
    if (!target) return false;
    var source = target.querySelector(MEDIA_TRIGGER);
    if (!source || typeof source.click !== 'function' || !returnToReviewList(detail)) return false;
    window.requestAnimationFrame(function () {
      source.click();
      window.requestAnimationFrame(function () {
        syncButtons(visibleDetail());
      });
    });
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var detail = visibleDetail();
      if (!detail || !e.target || typeof e.target.closest !== 'function') return;
      var direction = 0;
      if (e.target.closest(PREV)) direction = -1;
      if (e.target.closest(NEXT)) direction = 1;
      if (!direction) return;
      syncButtons(detail);
      if (!moveReview(detail, direction)) return;
      e.preventDefault();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    },
    true
  );

  // 右上×は詳細画面を抜ける操作。Judge.meのギャラリー終了後にテーマのレビューシートも閉じる。
  // 一覧へ戻る（左上）/投稿間移動ではreturnToReviewListが識別子を付けるため、この経路に入らない。
  document.addEventListener(
    'click',
    function (e) {
      var detail = visibleDetail();
      if (!detail || !e.target || typeof e.target.closest !== 'function') return;
      if (!e.target.closest(CLOSE) || detail.hasAttribute(RETURNING_TO_LIST)) return;
      window.setTimeout(function () {
        document.dispatchEvent(new CustomEvent('pdpr:close-review-modal'));
      }, 0);
    },
    true
  );

  // ライトボックスはbody直下に生成される。Tab/focusinだけ基盤モーダルのトラップ対象外へ出し、
  // Escは純正ライトボックスと下のシートを閉じる既存イベント列に委ねる。
  document.addEventListener(
    'keydown',
    function (e) {
      if (!(e.key === 'Tab' || e.keyCode === 9)) return;
      // キーボード操作が始まった＝以後は戻るボタンのフォーカスリングを通常どおり出す
      var suppressed = document.querySelectorAll('.' + SUPPRESS_RING_CLASS);
      for (var i = 0; i < suppressed.length; i++) {
        suppressed[i].classList.remove(SUPPRESS_RING_CLASS);
      }
      var detail = visibleDetail();
      if (!detail || !detail.contains(e.target)) return;
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      var detail = visibleDetail();
      if (!detail || !detail.contains(e.target)) return;
      syncButtons(detail);
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || typeof e.target.closest !== 'function') return;
      if (!e.target.closest(MEDIA_TRIGGER)) return;
      // Judge.me側がbubbleを止めても検知できるようcaptureで予約し、Vue描画後の2フレーム目に同期する。
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var detail = visibleDetail();
          syncButtons(detail);
        });
      });
    },
    true
  );

  // Judge.meはVueの描画完了後に詳細モーダルをbody直下へ追加する。画像クリックのcaptureだけでは
  // アプリ側がイベントを止めた／描画が遅延したケースを取りこぼし、テーマ所有classが付かない。
  // 追加そのものを監視して同じ同期を行うことで、純正サムネイル帯が残る状態を防ぐ。
  function syncInsertedDetail() {
    var detail = visibleDetail();
    if (!detail) {
      clearDetailSheetMode();
      return;
    }
    syncButtons(detail);
  }

  function observeDetailInsertion() {
    if (!document.body || typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(syncInsertedDetail);
    observer.observe(document.body, { childList: true, subtree: true });
    syncInsertedDetail();
  }

  if (document.body) {
    observeDetailInsertion();
  } else {
    document.addEventListener('DOMContentLoaded', observeDetailInsertion);
  }
})();

/* ==== [W8] #12 INQUIRY: contact form 送信後にモーダルを自動再オープン ==== */
(function () {
  'use strict';

  // why: contact form は送信でPDPが丸ごとリロードされ、成功/エラー表示がモーダル内に閉じ込められる。
  //      本体が data-pdpr-auto-open を出していれば、W6基盤の公開契約（data-pdpr-modal-open の click）
  //      でトリガーを programmatic click し再オープンする（基盤コードは触らない）。
  window.addEventListener('DOMContentLoaded', function () {
    var modal = document.querySelector('[data-pdpr-modal="inquiry"]');
    if (!modal) return;
    if (!modal.querySelector('[data-pdpr-auto-open]')) return;

    var trigger = document.querySelector('[data-pdpr-modal-open="inquiry"]');
    if (!trigger || typeof trigger.click !== 'function') return;
    trigger.click();
  });
})();

/* ==== [W8] PDP本文後ゾーン: #13 OSネイティブ共有（Web Share→clipboard→選択テキストの多段縮退） ==== */
(function () {
  var roots = document.querySelectorAll('[data-pdpr-share]');
  if (!roots.length) return;

  function showFeedback(fb, msg) {
    if (!fb) return;
    fb.textContent = msg;
    fb.classList.add('is-visible');
    clearTimeout(fb._pdprShareTimer);
    fb._pdprShareTimer = setTimeout(function () {
      fb.classList.remove('is-visible');
      fb.textContent = '';
    }, 2400);
  }

  // clipboardも不可のとき: URLをテキスト入力として露出し全選択（手動コピーの最終縮退）
  function revealFallback(input, fb, msg) {
    if (input) {
      input.hidden = false;
      try {
        input.focus();
        input.select();
        input.setSelectionRange(0, (input.value || '').length);
      } catch (e) {}
    }
    showFeedback(fb, msg);
  }

  function copyToClipboard(url, fb, input, msgs) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(function () {
        showFeedback(fb, msgs.copied);
      }).catch(function () {
        revealFallback(input, fb, msgs.manual);
      });
    } else {
      revealFallback(input, fb, msgs.manual);
    }
  }

  Array.prototype.forEach.call(roots, function (root) {
    var btn = root.querySelector('[data-pdpr-share-btn]');
    if (!btn) return;
    var fb = root.querySelector('[data-pdpr-share-feedback]');
    var input = root.querySelector('[data-pdpr-share-fallback]');
    var msgs = {
      copied: root.getAttribute('data-pdpr-share-msg-copied') || '',
      manual: root.getAttribute('data-pdpr-share-msg-manual') || ''
    };

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-pdpr-share-url') || window.location.href;
      var title = btn.getAttribute('data-pdpr-share-title') || document.title;

      if (navigator.share) {
        var shared;
        try {
          shared = navigator.share({ title: title, url: url });
        } catch (e) {
          // share自体が同期例外（データ不正等）＝クリップボード縮退へ
          copyToClipboard(url, fb, input, msgs);
          return;
        }
        if (shared && typeof shared.catch === 'function') {
          shared.catch(function (err) {
            // AbortError＝ユーザーが共有シートを閉じただけ＝縮退させない
            if (err && err.name === 'AbortError') return;
            copyToClipboard(url, fb, input, msgs);
          });
        }
      } else {
        copyToClipboard(url, fb, input, msgs);
      }
    });
  });
})();
/* ==== [W8] スタッフスナップ計測: GA4 カスタムイベント（台帳 docs/analytics-events.md） ==== */
(function () {
  'use strict';

  var body = document.body;
  if (!body) return;
  var measurementId = (body.getAttribute('data-ga4-id') || '').trim();
  if (!measurementId) return;

  var section = document.querySelector('[data-staff-snap-section]');
  if (!section) return;

  var MODAL_PREFIX = 'staff-snap-';
  var productHandle = section.getAttribute('data-staff-snap-section') || handleFromPath();

  function handleFromPath() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    if (!match) return '';
    try {
      return decodeURIComponent(match[1]);
    } catch (err) {
      return match[1];
    }
  }

  function gtag() {
    if (typeof window.gtag === 'function') return window.gtag;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    if (!document.querySelector('script[src*="googletagmanager.com/gtag/js"]')) {
      var script = document.createElement('script');
      script.async = true;
      script.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      (document.head || body).appendChild(script);
    }
    window.gtag('js', new Date());
    return window.gtag;
  }

  function send(name, params) {
    params.send_to = measurementId;
    gtag()('event', name, params);
  }

  function findModal(id) {
    if (!id) return null;
    var all = document.querySelectorAll('[data-pdpr-modal]');
    for (var i = 0; i < all.length; i++) {
      if (all[i].getAttribute('data-pdpr-modal') === id) return all[i];
    }
    return null;
  }

  function snapHandleOf(el) {
    var modal = el.closest('[data-pdpr-modal]');
    var id = modal ? modal.getAttribute('data-pdpr-modal') || '' : '';
    return id.indexOf(MODAL_PREFIX) === 0 ? id.slice(MODAL_PREFIX.length) : '';
  }

  if (typeof IntersectionObserver === 'function') {
    var viewSent = false;
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (viewSent || !entries[i].isIntersecting || entries[i].intersectionRatio < 0.5) continue;
          viewSent = true;
          observer.disconnect();
          send('staff_snap_view', {
            product_handle: productHandle,
            snap_count: section.querySelectorAll('[data-staff-snap-handle]').length
          });
          return;
        }
      },
      { threshold: 0.5 }
    );
    observer.observe(section);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;

    var trigger = target.closest('[data-staff-snap-handle][data-pdpr-modal-open]');
    if (trigger) {
      if (!findModal(trigger.getAttribute('data-pdpr-modal-open'))) return;
      send('staff_snap_open', {
        product_handle: productHandle,
        snap_handle: trigger.getAttribute('data-staff-snap-handle'),
        staff_handle: trigger.getAttribute('data-staff-snap-staff') || ''
      });
      return;
    }

    var item = target.closest('[data-staff-snap-item]');
    if (!item || item.hasAttribute('data-staff-snap-self')) return;
    send('staff_snap_item_click', {
      product_handle: productHandle,
      snap_handle: snapHandleOf(item),
      item_handle: item.getAttribute('data-staff-snap-item')
    });
  });
})();


(function () {
  'use strict';

  var SELF = '[data-staff-snap-self]';
  var PHOTO = '[data-staff-snap-photo]';
  var PREVIEW_CLASS = 'pswp--staff-snap';

  var gallery = null;
  var previewTrigger = null;
  var captionToken = 0;

  function closeSheet(node) {
    var modal = node.closest('.pdpr-modal');
    if (!modal) return;
    var close = modal.querySelector('[data-pdpr-modal-close]');
    if (close) close.click();
  }

  function inPreview(node) {
    return !!(node && typeof node.closest === 'function' && node.closest('.pswp'));
  }

  // PhotoSwipeのtouchstartはscroll-wrap、move/endはwindow＝ここで止めるとW6の下スワイプ閉じだけが外れる
  function blockSheetSwipe(pswpEl) {
    if (pswpEl._staffSnapSwipeGuard) return;
    pswpEl._staffSnapSwipeGuard = true;
    pswpEl.addEventListener(
      'touchstart',
      function (e) {
        if (gallery) e.stopPropagation();
      },
      false
    );
  }

  // 開くアニメーション中はプレースホルダのimgが写真の箱を持つ＝実画像の差し替えを待たずに追える
  function imageRect(pswpEl) {
    var images = pswpEl.querySelectorAll('.pswp__img');
    for (var i = 0; i < images.length; i++) {
      var r = images[i].getBoundingClientRect();
      if (r.height > 0 && r.left < window.innerWidth && r.right > 0) return r;
    }
    return null;
  }

  // 測れないときは top を入れない＝CSSの下端固定のまま縮退する
  function placeCaption(pswpEl) {
    var caption = pswpEl.querySelector('.pswp__caption:not(.pswp__caption--fake)');
    var rect = imageRect(pswpEl);
    if (!caption || !rect) return;
    caption.style.top = Math.round(rect.bottom + 16) + 'px';
    caption.style.bottom = 'auto';
  }

  // 開くアニメーションは数フレーム遅れて始まる＝止まった瞬間で打ち切らず一定フレーム追い続ける
  function trackCaption(pswpEl) {
    var token = ++captionToken;
    var frames = 45;
    var last = null;
    (function step() {
      if (!gallery || token !== captionToken) return;
      var rect = imageRect(pswpEl);
      if (rect) {
        var bottom = Math.round(rect.bottom);
        if (bottom !== last) {
          last = bottom;
          placeCaption(pswpEl);
        }
      }
      frames--;
      if (frames > 0) window.requestAnimationFrame(step);
    })();
  }

  function resetCaption(pswpEl) {
    var caption = pswpEl.querySelector('.pswp__caption:not(.pswp__caption--fake)');
    if (!caption) return;
    caption.style.top = '';
    caption.style.bottom = '';
  }

  function setCaption(item, captionEl) {
    var center = captionEl.children && captionEl.children[0];
    if (!center) return false;
    center.textContent = item.title || '';
    return !!item.title;
  }

  function openPreview(trigger) {
    if (typeof window.PhotoSwipe !== 'function' || typeof window.PhotoSwipeUI_Default !== 'function') return;
    var pswpEl = document.querySelector('.pswp');
    if (!pswpEl) return;
    var src = trigger.getAttribute('data-staff-snap-src');
    var width = parseInt(trigger.getAttribute('data-staff-snap-width'), 10);
    var height = parseInt(trigger.getAttribute('data-staff-snap-height'), 10);
    if (!src || !width || !height) return;
    var thumb = trigger.querySelector('img');
    var items = [
      {
        src: src,
        w: width,
        h: height,
        msrc: thumb ? thumb.currentSrc || thumb.src : null,
        el: thumb || trigger,
        title: trigger.getAttribute('data-staff-snap-caption') || '',
      },
    ];
    var options = {
      index: 0,
      mainClass: PREVIEW_CLASS,
      bgOpacity: 1,
      captionEl: true,
      arrowEl: false,
      counterEl: false,
      fullscreenEl: false,
      preloaderEl: false,
      shareEl: false,
      zoomEl: false,
      closeOnScroll: false,
      history: false,
      tapToToggleControls: false,
      timeToIdle: 0,
      timeToIdleOutside: 0,
      addCaptionHTMLFn: setCaption,
      getThumbBoundsFn: function () {
        var el = thumb || trigger;
        var rect = el.getBoundingClientRect();
        return { x: rect.left, y: rect.top + (window.pageYOffset || 0), w: rect.width };
      },
    };
    blockSheetSwipe(pswpEl);
    previewTrigger = trigger;
    gallery = new window.PhotoSwipe(pswpEl, window.PhotoSwipeUI_Default, items, options);
    var onResize = function () {
      if (gallery) trackCaption(pswpEl);
    };
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    gallery.listen('destroy', function () {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
      resetCaption(pswpEl);
      gallery = null;
      if (previewTrigger && typeof previewTrigger.focus === 'function') {
        previewTrigger.focus({ preventScroll: true });
      }
      previewTrigger = null;
    });
    gallery.init();
    trackCaption(pswpEl);
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || typeof target.closest !== 'function') return;
    var self = target.closest(SELF);
    if (self) {
      e.preventDefault();
      closeSheet(self);
      return;
    }
    var photo = target.closest(PHOTO);
    if (photo) openPreview(photo);
  });

  document.addEventListener(
    'keydown',
    function (e) {
      if (!gallery) return;
      if (e.key === 'Escape' || e.keyCode === 27) {
        e.preventDefault();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        gallery.close();
        return;
      }
      if ((e.key === 'Tab' || e.keyCode === 9) && inPreview(e.target)) {
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
      }
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (e) {
      if (!gallery || !inPreview(e.target)) return;
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    },
    true
  );
})();

/* ==== [W7] PDPサイズ情報: 実寸表・サイズガイド台帳 ====
 * JSなし。#6.1実寸サイズモーダルの開閉はW6基盤（data-pdpr-modal-open="size"）に委譲し、
 * 実寸表・台帳マッチングはLiquid（商品metafield/metaobject）で静的描画する。
 * 追加ロジックが必要になった場合のみ、この領域にIIFEで足す（領域規約=plan.md §2）。 */

(function () {
  if (!document.body.classList.contains('_search')) return;
  var selector = '.shopify-section-group-header-group, #SiteHeader';
  var pending = false;
  var observer = window.ResizeObserver ? new ResizeObserver(schedule) : null;

  function sync() {
    pending = false;
    var bottom = 0;
    document.querySelectorAll(selector).forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.height > 0) bottom = Math.max(bottom, rect.bottom);
    });
    document.body.style.setProperty('--search-panel-top', Math.round(bottom) + 'px');
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(sync);
  }

  function observe() {
    if (!observer) return;
    observer.disconnect();
    document.querySelectorAll(selector).forEach(function (el) {
      observer.observe(el);
    });
  }

  sync();
  observe();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('shopify:section:load', function () {
    observe();
    schedule();
  });
})();
